import SelectEntriesSection from './SelectEntriesSection';

export default SelectEntriesSection;
